import styled from 'styled-components'

export const StyledProjectsLayout = styled.div`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
    height: 100%;
`
